angular.module('mean.contacts').controller('RequestContactController', ['$scope', 'Global', 'Contacts', 'MeanUser', 'userService', 'ngDialog', 'toaster', '$window', '$rootScope', 'Builders', '$filter',
  function($scope, Global, Contacts, MeanUser, userService, ngDialog, toaster, $window, $rootScope, Builders, $filter) {
    $scope.global = Global;
    $scope.package = {
      name: 'contacts'
    };

    $scope.user = $scope.$parent.user;
    $scope.is_builder = $scope.$parent.is_builder;

    console.log('in the controller' + $scope.requests);

    // if(!$scope.is_builder) {
    //     $scope.requests.forEach(function(request) {
    //         Builders.query({'builder': request.requestor._id}, function(builder) {
    //             var div = $filter('filter')(builder[0].division, {'_id': request.division}, true);
    //             request.div_name = div[0].name;
    //         });

    //     });
    // }

    function findValue(array, nameWeAreLookingFor) {
        for(var i = 0; i<array.length; i++) {
            if(array[i].requestor._id === nameWeAreLookingFor) return i;
        }
        return -1;
    }

    //this will update the database entry for contacts
    //and it will remove the request.  Add everything
    //to the personal list.  User can move to business later
    $scope.acceptRequest = function(item) {
        $scope.contacts = this.$parent.contacts;
        if(!$scope.contacts) {
            toaster.pop('error', 'Contacts', 'Problem with the user database. Contact Admin');
            return;
        }

        if(item.type === 'Personal') {
            $scope.contacts.personal.push(item.requestor._id);
        } else {
            if($scope.is_builder)
              $scope.contacts.trades.push(item.requestor._id);
            else {
                $scope.contacts.builders.push(item.requestor._id);
            }
        }

        $scope.contacts.$update(function(results) {
            //we saved the contact, now it's time to update the requestee
            Contacts.query({'user': item.requestor._id}, function(contacts) {
                if(contacts.length === 1) {
                    if(item.type === 'Personal') {
                        contacts[0].personal.push(item.requestee._id);
                    } else {
                        if($scope.is_builder) {
                            contacts[0].builders.push(item.requestee._id);
                        } else {
                            contacts[0].trades.push(item.requestee._id);
                        }
                    }
                    contacts[0].$update();
                }
                var index = $scope.requests.indexOf(item);
                $scope.requests.splice(index, 1);
                item.$delete();
                $rootScope.$broadcast('update-contact-list');
                toaster.pop('success', 'Contacts', 'New contact added');
            });
        }, function(error) {
            toaster.pop('error', 'Contacts', error);
        });
    };

    $scope.closeWindow = function() {
        $window.location.reload();
    };

    //this will just remove the request
    $scope.declineRequest = function(item) {
        item.$delete(function(result) {
            var index = $scope.requests.indexOf(result);
            $scope.requests.splice(index, 1);
            $rootScope.$broadcast('update-contact-list');
            toaster.pop('success', 'Contacts', 'Contact Request Removed');
        }, function(error) {
            toaster.pop('error', 'Contacts', error);
        });
    };
  }
]);



// WEBPACK FOOTER //
// ./packages/custom/contacts/public/controllers/requestContactController.js